<template>
    <div class="card" v-if="event">

        <div class="card-header" v-if="event.source">
            <h5 :class="titleClass" class="card-title" v-if="event.title">
                {{ event.title }}
            </h5>
            <p class="text-center">
                <event-value v-if="correctEventValue" :event_value="correctEventValue" :options="{ always_visible: true }" @user-labels-change="updateUserLabels"></event-value>
            </p>
            <p class="card-text text-center" v-if="event.source">
                <i class="fas fa-link"></i> Source: {{ event.source }}
            </p>
            <a :href="event.report_url" class="btn btn-primary btn-sm" target="_blank" v-if="event.report_url">
                <i class="fas fa-file-alt"></i> Report
            </a>
            <a :href="event.related_url" class="btn btn-secondary btn-sm" target="_blank" v-if="event.related_url">
                <i class="fas fa-external-link-alt"></i> Related Link
            </a>
        </div>

        <div class="card-body">
            <div class="row" v-for="(values, key) in filteredEventData" :key="key">
                <div class="col-6 text-end fw-bold">
                    <i :class="event_value_name_to_info[key]?.icon || 'fas fa-info-circle'"></i>
                    {{ event_value_name_to_info[key]?.name || key }}:
                </div>
                <div class="col-6">
                    <div v-if="key == 'species'" class="form-check" title="Only show the most specific species names">
                        <input class="form-check-input" type="checkbox" id="showMinimalSpecies" v-model="showMinimalSpecies" checked>
                        <label class="form-check-label hint-text" for="showMinimalSpecies">
                            Most specific only
                        </label>
                    </div>
                    <div v-for="(value, index) in values" :key="index">
                        <event-value v-if="key != '_correct'" :event_value="value" :key="index"></event-value>
                    </div>
                </div>
            </div>

            <div class="row" v-if="event.external_id">
                <div class="col-6 text-end fw-bold"> <i class="fas fa-archive"></i> External ID:</div>
                <div class="col-6">{{ event.external_id }}</div>
            </div>
            
            <div class="row" v-if="event.text">
                <div class="col-12 resizable-text small" v-html="event.text">
                </div>
            </div>
        </div>

        <div class="card-footer">
        </div>
    </div>
</template>

<script>
import EventValueComponent from './event-value.vue';

export default {
    name: "event",
    components: {
        'event-value': EventValueComponent,
    },
    data() {
        return {
            correctEventValue: null,
            event_value_name_to_info: {
                places: { name: "Places", icon: "fas fa-map-marker-alt" },
                event_date: { name: "Event date", icon: "fas fa-calendar-day" },
                publication_date: { name: "Publication date", icon: "fas fa-calendar-alt" },
                disease: { name: "Disease / Serotypes", icon: "fas fa-vial" },
                species: { name: "Species", icon: "fas fa-dog" },
                mortality: { name: "Mortality", icon: "fas fa-notes-medical" },
                cases: { name: "Cases", icon: "fas fa-notes-medical" },
                environment: { name: "Environment", icon: "fas fa-leaf" },
                keywords: { name: "Keywords", icon: "fas fa-tags" },
                symptoms: { name: "Symptoms", icon: "fas fa-head-side-cough" },
                _correct: { name: "", icon: "fas fa-check" }
            },
            showMinimalSpecies: true
        }
    },
    props: {
        event: {
            type: Object,
            required: true
        }
    },
    computed: {
        minimalSpeciesNames() {
            const speciesValues = this.event.data.species || [];
            const speciesNames = speciesValues.map(species => species.value);
            console.log("speciesNames", speciesNames);
            return this.getMinimalNames(speciesNames);
        },
        filteredEventData() {
            const filteredData = { ...this.event.data };

            // remove _correct
            delete filteredData._correct;

            if (!this.showMinimalSpecies) {
                return this.event.data;
            }

            if (filteredData.species) {
                filteredData.species = filteredData.species.filter(species => this.minimalSpeciesNames.includes(species.value));
            }
            
            
            return filteredData;
        },
        eventIsIncorrect() {
            if (!this.correctEventValue) {
                return false;
            }
            return this.correctEventValue.user_labels && this.correctEventValue.user_labels.some(label => label.correct === false);
        },
        titleClass() {
            return this.eventIsIncorrect ? 'incorrect-title' : '';
        }
    },
    watch: {
        event: {
            handler: function (val, oldVal) {
                if (oldVal == val)
                    return;

                let event_values = {};
                for (let key in this.event_value_name_to_info) {
                    if (this.event.data[key] && key != "cases") {
                        event_values[key] = this.event.data[key];
                    }
                }
                this.event.data = event_values;
                this.correctEventValue = this.event.data._correct[0];
            },
            deep: true
        }
    },
    mounted() {
    },
    methods: {
        getMinimalNames(species_names) {
          const minimal_names = new Set();
        
          species_names.forEach(name => {
            let is_minimal = true;
        
            $species.forEach(species_array => {
              const index = species_array.indexOf(name.toLowerCase());
              if (index !== -1) {
                for (let i = 0; i < index; i++) {
                  if (species_names.includes(species_array[i])) {
                    is_minimal = false;
                    break;
                  }
                }
              }
            });
        
            if (is_minimal) {
              minimal_names.add(name);
            }
          });
        
          return Array.from(minimal_names);
        },
        updateUserLabels(newLabels) {
            console.log("newLabels", newLabels);
            this.correctEventValue.user_labels = newLabels;
        }
    }
}
</script>

<style scoped>
.resizable-text {
    max-height: 200px;
    overflow-y: auto;
    resize: vertical;
    margin-top: 25px;
    background-color: #F5F5F5;
    border: 1px solid #CCCCCC;
    border-radius: 5px;
    padding: 15px;
}
                
.hint-text {
    font-size: 0.875rem; /* Smaller text size */
    color: gray;
}

.incorrect-title {
    color: gray;
    text-decoration: line-through;
}
</style>